import React from "react";

const IconAutomatic = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.463867" width="48" height="48" rx="24" fill="#006F94" />
      <path
        d="M15.6395 13.9807C15.6395 14.8671 14.921 15.5856 14.0347 15.5856C14.921 15.5856 15.6395 16.3041 15.6395 17.1904C15.6395 16.3041 16.358 15.5856 17.2444 15.5856C16.358 15.5856 15.6395 14.8671 15.6395 13.9807Z"
        fill="white"
      />
      <path
        d="M14.0347 15.5856C14.921 15.5856 15.6395 14.8671 15.6395 13.9807C15.6395 14.8671 16.358 15.5856 17.2444 15.5856C16.358 15.5856 15.6395 16.3041 15.6395 17.1904C15.6395 16.3041 14.921 15.5856 14.0347 15.5856"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M30.0531 12.7471C30.0531 13.9741 29.0584 14.9687 27.8314 14.9687C29.0584 14.9687 30.0531 15.9634 30.0531 17.1904C30.0531 15.9634 31.0477 14.9687 32.2747 14.9687C31.0477 14.9687 30.0531 13.9741 30.0531 12.7471Z"
        fill="white"
      />
      <path
        d="M27.8314 14.9687C29.0584 14.9687 30.0531 13.9741 30.0531 12.7471C30.0531 13.9741 31.0477 14.9687 32.2747 14.9687C31.0477 14.9687 30.0531 15.9634 30.0531 17.1904C30.0531 15.9634 29.0584 14.9687 27.8314 14.9687"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M19.1546 12.747C20.8653 12.747 22.2521 11.3602 22.2521 9.64941C22.2521 11.3602 23.639 12.747 25.3497 12.747C23.639 12.747 22.2521 14.1338 22.2521 15.8445C22.2521 14.1338 20.8653 12.747 19.1546 12.747"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M26.5288 24.677L30.7924 28.9407C32.6649 30.8131 32.8792 33.6386 31.2662 35.2516L28.3222 38.1956C26.7092 39.8086 23.8837 39.5943 22.0113 37.7219L17.7476 33.4582"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M18.8359 34.5632L17.7362 33.4634C17.1271 32.8544 17.1271 31.873 17.7362 31.2696C18.3453 30.6605 19.3266 30.6605 19.9301 31.2696L21.0298 32.3693"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M20.4374 31.7661L19.3377 30.6663C18.7286 30.0572 18.7286 29.0759 19.3377 28.4724C19.9468 27.8634 20.9281 27.8634 21.5315 28.4724L22.6313 29.5722"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M22.1352 29.0703L21.0354 27.9705C20.4263 27.3614 20.4263 26.3801 21.0354 25.7766C21.6445 25.1675 22.6258 25.1675 23.2293 25.7766L24.329 26.8764"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M24.3291 26.8762L18.1196 20.6668C17.5105 20.0577 17.5105 19.0764 18.1196 18.4729C18.7287 17.8638 19.7101 17.8638 20.3135 18.4729L26.5229 24.6824"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M24.7294 22.9568V19.5785C24.7294 18.7213 25.4231 18.0276 26.2803 18.0276C27.1376 18.0276 27.8313 18.7213 27.8313 19.5785V26.0643"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M29.4802 24.9452L33.9653 23.3258"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M29.4177 22.9119L32.079 18.9552"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M14.296 22.1615L18.6367 24.1355"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M14.0347 27.3719L18.6367 26.123"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default IconAutomatic;
